<template>
  <div class="gsxwBox">

    <div class="gsxwnei">
      <div class="gsxwHeader">
        <div class="gsxw_left">Company News</div>
        <div class="gsxw_right" @click="gsxwCK">
          <div class="gsxw_text_dd_1">View More</div>
          <div ><i class="el-icon-right"></i></div>
        </div>
      </div>
    <div class="contentBox">
      <div class="itemBox" v-for="item in gsxwItem" v-on:mouseenter="mouseeon(item.indexPath)" :style="{backgroundColor:item.backcolor}">
        <div class="gsxw_item_img">
          <el-image class="ttyy"
            style="width: 376px; height: 284px"
            :src="item.imgUrl"
            :fit="contain"></el-image>
        </div>
        <div class="gsxw_item_p1">
          {{item.text1}}
        </div>
        <el-divider></el-divider>
        <div class="gsxw_item_p2">
          {{item.text2}}
        </div>
        <div class="gsxw_item_p3" @click="gsxwToItem(item.indexPath)">
          <div class="gsxw_item_p3_1">
            {{item.text3}}
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<style scoped>
.ttyy{
  border-radius: 10px;
}
.gsxw_item_p3_1{
  background-color: #5daf34;
  width: 123px;
  height: 36px;
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gsxw_item_p3{
  display: flex;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
}
.gsxw_item_p2{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  text-align: center;
}
.gsxw_item_p1{
  font-family: SourceHanSansCN;
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin-top: 15px;
}
.itemBox{
  margin-right: 15px;
  height: 483px;
  border-bottom: 1px solid #666666;
  border-radius: 10px;
}
.gsxwnei{
  width: 1176px;
}
.contentBox{
  width: 1176px;
  display: flex;
}
.gsxw_text_dd_1{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.gsxw_right{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #8c939d;
  letter-spacing: 0;
  text-align: justify;
  display: flex;
  cursor: pointer;
}
.gsxw_left{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0.64px;
  text-align: justify;
}
.gsxwHeader{
  width: 1176px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.gsxwBox{
  width: 1920px;
  /*height: 710px;*/
  background: #FFFFFF;
  padding: 0 0 100px 0px;
  margin: 0 auto;
  display: flex;
  justify-content: center;

}


</style>
<script>
export default {
  name: "gsxw",
  data() {
    return {
      gsxwItem:[
        {
          imgUrl:"http://116.62.38.250//image/sy/news1.jpg",
          text1:"March 19, 2024",
          text2:"Er:YAG Laser Treatment... ",
          text3:"Learn More",
          indexPath:"gss",
          backcolor:"#FFFFFF"
        },
        {
          imgUrl:"http://116.62.38.250//image/sy/news2.jpg",
          text1:"March 20, 2024",
          text2:"The Grand Opening of th...",
          text3:"Learn More",
          indexPath:"gxx",
          backcolor:"#FFFFFF"
        },
        {
          imgUrl:"http://116.62.38.250//image/sy/news3.jpg",
          text1:"March 27, 2024",
          text2:"Micro-Innovation | Marc...",
          text3:"Learn More",
          indexPath:"gyy",
          backcolor:"#FFFFFF"
        }
      ]
    }
  },
  methods:{
    gsxwCK(){
      this.$router.push('/en/news2');
    },
    gsxwToItem(path){
      this.$router.push('/en/newsItem?index='+path);
    },
    mouseeon(path){
      let that = this;
      for(let index in that.gsxwItem){
        let itemData = that.gsxwItem[index];
        if(path == itemData.indexPath){
          itemData.backcolor = "#F3F4F8"
        } else {
          itemData.backcolor = "#FFFFFF"
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/en/image/gsxw.vue